import {
  baseRequestWithAxiosResponse,
  baseRequestWithHeaders,
} from './base-request';

export const getExistingUsers = (centerId) => {
  const url = `network-center/get-dashboard-users?centerId=${centerId}`;
  const method = 'GET';
  return baseRequestWithHeaders(url, method, null);
};

export const addNewUser = (body) => {
  console.log(body, '[body]');
  const url = `network-center/create-new-account`;
  const method = 'POST';
  return baseRequestWithHeaders(url, method, null, body);
};

export const fetchSpocUser = (search) => {
  const url = `network-center/search-ops-users?search=${search}`;
  const method = 'GET';
  return baseRequestWithHeaders(url, method, null);
};

export const updateDashboardUser = (id, updates) => {
  const url = `network-center/update-user/${id}`
  const method = 'POST'
  return baseRequestWithAxiosResponse(url, method, null, updates)
}

export const getCentralUserCenters = (id) => {
  const url = `/network-center/user-centers/${id}`
  const method = 'GET'
  return baseRequestWithAxiosResponse(url, method, null, null)
}